<template>
  <div class="hide-sm">
    <v-menu
      bottom
      rounded
      transition="slide-y-transition"
      nudge-bottom="4"
      max-width="300"
      offset-y
    >
      <template #activator="{ on: onMenu }">
        <v-tooltip bottom :open-on-focus="false">
          <template #activator="{ on: onTooltip }">
            <v-btn icon v-on="{ ...onMenu, ...onTooltip }">
              <i class="pi pi-inbox p-fs-xxxl text-p-dark"></i>
            </v-btn>
          </template>
          <span> پیام ها </span>
        </v-tooltip>
      </template>
      <v-list>
        <v-list-item
          class="msg-list-item"
          v-for="(message, index) in messages.slice(0, 5)"
          :key="index"
          dense
        >
          <v-list-item-title>
            <v-icon size="8" color="second" class="me-1">mdi-circle</v-icon>
            {{ message.subject }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item class="p-fs-n" v-if="messages && messages.length === 0">
          {{ label.caption.noMessage }}
        </v-list-item>
        <v-list-item dense class="mt-1">
          <v-btn text small block to="#">
            <i class="pi pi-inbox p-fs-xxxxl text-p-dark"></i>
            {{ label.menu.allMessages }}
          </v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import label from "@/lang/StaticLabels.js";

export default {
  name: "TheMessageDropDown",
  data() {
    return {
      label,
      messages: [
        { subject: "به نرم‌افزار میتـــا خوش آمدید ..." },
        { subject: "جهت بروزرسانی اطلاعات از قسمت ویرایش پروفایل در ..." },
        { subject: "پیام شخصی از طرف سمیرا حسینی" },
      ],
    };
  },
};
</script>
